export enum IrsMaximumsFrequencyTypes {
  ANNUALLY = 'ANNUALLY',
  MONTHLY = 'MONTHLY',
}

export enum IrsMaximumsCoverageTypes {
  INDIVIDUAL = 'INDIVIDUAL',
  FAMILY = 'FAMILY',
  ROLLOVER = 'ROLLOVER',
}